var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArticleOnboarding = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#article-onboarding_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#article-onboarding_svg__b)",
  d: "M24.009 48c13.24 0 23.974-10.745 23.974-24S37.249 0 24.009 0 .035 10.745.035 24 10.77 48 24.01 48"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#article-onboarding_svg__c)",
  d: "M18.168 30.523C16.372 21.53 11.6 14.39 4.918 9.445.09 15.797-1.482 24.452 1.55 32.434c3.538 9.274 12.128 15.119 21.392 15.513-2.358-5.621-3.818-11.804-4.773-17.424"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#article-onboarding_svg__d)",
  d: "M29.953.785c.73.9 1.404 1.799 2.021 2.754 7.917 12.085 1.348 25.743.73 38.783-.112 1.292-.112 2.641.112 3.99C45 41.535 51.064 27.82 46.46 15.512A24.13 24.13 0 0 0 29.953.784"
}), /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 38,
  x: 8,
  y: 16,
  fill: "#fff",
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 10,
  x: 12,
  y: 20,
  fill: "#BB7EC3",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 10,
  height: 2,
  x: 26,
  y: 20,
  fill: "url(#article-onboarding_svg__e)",
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 10,
  height: 2,
  x: 26,
  y: 24,
  fill: "url(#article-onboarding_svg__f)",
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 10,
  height: 2,
  x: 26,
  y: 28,
  fill: "url(#article-onboarding_svg__g)",
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 2,
  x: 12,
  y: 34,
  fill: "url(#article-onboarding_svg__h)",
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 2,
  x: 12,
  y: 38,
  fill: "url(#article-onboarding_svg__i)",
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 2,
  x: 12,
  y: 42,
  fill: "url(#article-onboarding_svg__j)",
  rx: 1
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "article-onboarding_svg__b",
  x1: -13.523,
  x2: 37.084,
  y1: -9.181,
  y2: 35.466,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.002,
  stopColor: "#EF7361"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FD8A82"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "article-onboarding_svg__c",
  x1: -15.94,
  x2: 18.103,
  y1: 19.793,
  y2: 30.388,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.002,
  stopColor: "#EF7361"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FD8A82"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "article-onboarding_svg__d",
  x1: 14.934,
  x2: 48.283,
  y1: 7.265,
  y2: 36.687,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.002,
  stopColor: "#EF7361"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FD8A82"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "article-onboarding_svg__e",
  x1: 25.997,
  x2: 35.995,
  y1: 21.003,
  y2: 21.003,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.006,
  stopColor: "#BB7EC3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5A6FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "article-onboarding_svg__f",
  x1: 25.997,
  x2: 35.995,
  y1: 25.003,
  y2: 25.003,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.006,
  stopColor: "#BB7EC3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5A6FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "article-onboarding_svg__g",
  x1: 25.997,
  x2: 35.995,
  y1: 29.003,
  y2: 29.003,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.006,
  stopColor: "#BB7EC3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5A6FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "article-onboarding_svg__h",
  x1: 11.992,
  x2: 35.987,
  y1: 35.003,
  y2: 35.003,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.006,
  stopColor: "#BB7EC3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5A6FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "article-onboarding_svg__i",
  x1: 11.992,
  x2: 35.987,
  y1: 39.003,
  y2: 39.003,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.006,
  stopColor: "#BB7EC3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5A6FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "article-onboarding_svg__j",
  x1: 11.995,
  x2: 25.992,
  y1: 43.003,
  y2: 43.003,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.006,
  stopColor: "#BB7EC3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5A6FF"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "article-onboarding_svg__a"
}, /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 48,
  fill: "#fff",
  rx: 24
})))));
export default SvgArticleOnboarding;